import { render, staticRenderFns } from "./document-minus-outline.vue?vue&type=template&id=66d473bd&scoped=true"
var script = {}
import style0 from "./document-minus-outline.vue?vue&type=style&index=0&id=66d473bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d473bd",
  null
  
)

export default component.exports